import React, { Component } from "react";
import { Button, Input, message } from "antd";
export default class ToaDo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      geoArray: [["", ""]],
    };
  }

  onChangeInputGeo(e, index, xy) {
    const { value } = e.target;
    const reg = /^-?[0-9]*(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === "") {
      let geoA = this.state.geoArray;
      geoA[index][xy] = e.target.value;
      this.setState({
        geoArray: geoA,
      });
    }
  }

  onFocusOut(e, index, xy) {
    let check = true;
    let data = [...this.state.geoArray];
    for (let i = 0; i < this.state.geoArray.length; i++) {
      if (
        this.state.geoArray[i][0].length === 0 ||
        this.state.geoArray[i][1].length === 0
      )
        check = false;
    }

    if (check) {
      for (let i = 0; i < this.state.geoArray.length; i++) {
        if (
          this.state.geoArray[i][0] > 10000000 ||
          this.state.geoArray[i][1] > 10000000
        ) {
          message.error("Không có thông tin (dữ liệu đang cập nhật)");
          return;
        }
      }
    }
    if (check) {
      let geoA = this.state.geoArray;
      geoA.push(["", ""]);
      this.setState({
        geoArray: geoA,
      });
      this.props.drawPolygonSearch(data);
    }
  }

  onResetButton() {
    this.setState({
      geoArray: [["", ""]],
    });
    this.props.resetMap();
  }

  onSearch = () => {
    let x = 0;
    let y = 0;
    let count = 0;
    for (let i = 0; i < this.state.geoArray.length; i++) {
      if (
        this.state.geoArray[i][0].length > 0 &&
        this.state.geoArray[i][1].length > 0 &&
        !isNaN(parseFloat(this.state.geoArray[i][0])) &&
        !isNaN(parseFloat(this.state.geoArray[i][0]))
      ) {
        x = x + parseFloat(this.state.geoArray[i][0]);
        y = y + parseFloat(this.state.geoArray[i][1]);
        count++;
      }
    }
    if (count > 0) {
      for (let i = 0; i < this.state.geoArray.length; i++) {
        if (
          this.state.geoArray[i][0] > 10000000 ||
          this.state.geoArray[i][1] > 10000000
        ) {
          message.error(" Không có thông tin (dữ liệu đang cập nhật)");
          return;
        }
      }
    }

    if (count > 0) {
      let data = {
        toaDoX: y / count, //reverse x,y
        toaDoY: x / count,
      };
      this.props.onSearch(data, "searchByForm");
    }
  };

  render() {
    return (
      <div>
        <div className="group">
          <div className="gr-title">
            <div className="required">*</div>
            <div className="text">Toạ độ</div>
          </div>
        </div>

        {this.state.geoArray.map((geo, index) => (
          <div key={index} className="toa-do">
            <div className="toa-do-index">{index + 1}</div>
            <Input
              type="text"
              className="input-geo"
              placeholder="X"
              value={geo[1]}
              onChange={(e) => this.onChangeInputGeo(e, index, 1)}
              onMouseLeave={(e) => this.onFocusOut(e, index, 1)}
            />

            <Input
              type="text"
              className="input-geo"
              placeholder="Y"
              value={geo[0]}
              onChange={(e) => this.onChangeInputGeo(e, index, 0)}
              onMouseLeave={(e) => this.onFocusOut(e, index, 1)}
            />
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            className="button"
            onClick={() => {
              this.onResetButton();
            }}
          >
            Tìm mới
          </Button>
          <Button
            type="primary"
            className="button"
            onClick={() => {
              this.onSearch();
            }}
          >
            Tìm kiếm
          </Button>
        </div>
      </div>
    );
  }
}
